
export default () => ({
    loading: true,
    reserves: [],
    currentReserve: null
})
